import SafeUncontrolledPopover from 'components/SafeUncontrolledPopover';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, PopoverBody } from 'reactstrap';
import {
  getCampaignHasFeatureEnabled,
  PERFORMANCE_FEATURE_PROMOTION_NOMINATION_BY_MANAGER_ALLOW_COMMENTS,
} from 'utils/models/PerformanceUtils';
import { CampaignWithConfigs, PromotionPacketInfo } from '../../../../types';

interface PromotionNominationInfoProps {
  recommendForPromotion: boolean;
  promotionComments?: string;
  campaign?: CampaignWithConfigs;
  promotionPacket?: PromotionPacketInfo;
}

const PromotionNominationInfo: React.FC<PromotionNominationInfoProps> = ({
  recommendForPromotion,
  promotionComments,
  campaign,
  promotionPacket,
}) => {
  return (
    <Col className="col-auto">
      <h6 className="text-secondary text-uppercase">
        <FormattedMessage
          id="app.views.person.person_performance.trajectory.manager_rating_card.nominated_for_promotion"
          defaultMessage="Nominated for promotion"
        />
      </h6>
      <h2 className="mb-3">
        <span id="promotion-nomination-value">
          {recommendForPromotion ? (
            <FormattedMessage
              id="app.views.person.person_performance.trajectory.manager_rating_card.yes"
              defaultMessage="Yes"
            />
          ) : (
            <FormattedMessage
              id="app.views.person.person_performance.trajectory.manager_rating_card.no"
              defaultMessage="No"
            />
          )}
        </span>
        {promotionComments &&
          getCampaignHasFeatureEnabled(
            campaign,
            PERFORMANCE_FEATURE_PROMOTION_NOMINATION_BY_MANAGER_ALLOW_COMMENTS
          ) && (
            <SafeUncontrolledPopover
              trigger="hover"
              placement="bottom"
              target="promotion-nomination-value"
            >
              <PopoverBody>{promotionComments}</PopoverBody>
            </SafeUncontrolledPopover>
          )}
        {promotionPacket && (
          <a
            href={`/packets/${promotionPacket.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-decoration-none"
          >
            <i className="fe fe-file-text text-primary ps-2" />
          </a>
        )}
      </h2>
    </Col>
  );
};

export default PromotionNominationInfo;
